module.exports = __webpack_public_path__ + "static/media/9.2e5c8d22.jpg";